import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetCarWashListResponse, GetCarWashListRequest, PostCarWashRequest, GetCarWashCompanyNamesListResponse, GetCarWashCompanyNamesListRequest } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'car-wash-purchase.component.html',
  styleUrls: ['./car-wash-purchase.component.scss']
})
export class CarWashPurchaseComponent implements OnInit {

  carWashResponse: GetCarWashListResponse | null = null;
  carWashCompaniesResponse: GetCarWashCompanyNamesListResponse | null = null;
  carWashAmount: number = 0;
  carWashCompanyId: number = 0;
  popupVisibleError: boolean = false;
  errorMessage: string = '';
  isPopupVisible = false;
  isMobile: boolean = false;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    if (!activeVoucher || activeVoucher.id === 0) {
      this.navigateToVoucher();
    } else {
      this.checkIfMobile();
      this.loadCarWashList();
      this.loadCarWashCompanyList();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  loadCarWashList() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    if (activeVoucher) {
      const request: GetCarWashListRequest = { voucherId: activeVoucher.id };
      this.courierService.getCarWashList(request).subscribe((response: GetCarWashListResponse) => {
        this.carWashResponse = response;
      });
    } 
  }

  loadCarWashCompanyList() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    if (activeVoucher) {
      const request: GetCarWashCompanyNamesListRequest = { voucherId: activeVoucher.id };
      this.courierService.getCarWashCompanyNamesList(request).subscribe((response: GetCarWashCompanyNamesListResponse) => {
        this.carWashCompaniesResponse = response;
      });
    } 
  }

  navigateToVoucher() {
    this.router.navigate(['/voucher']);
  }

  saveClick() {
    const errors: string[] = [];

    if (!this.carWashAmount || this.carWashAmount <= 0) {
      errors.push(this.translate.instant('InvalidQuantityPleaseEnterAValidQuantity'));
    }

    if (!this.carWashCompanyId || this.carWashCompanyId <= 0) {
      errors.push(this.translate.instant('NoCarWashSelectedPleaseSelectACarWash'));
    }

    if (errors.length > 0) {
      this.errorMessage = errors.join('<br/><br/>');
      this.popupVisibleError = true;
      return;
    }

    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    if (!activeVoucher) {
      this.navigateToVoucher();
      return;
    }

    const request: PostCarWashRequest = {
      vouchersId: activeVoucher.id,
      amount: this.carWashAmount,
      carWashCompanyId: this.carWashCompanyId
    };

    this.courierService.postCarWash(request).subscribe(() => {
      this.navigateToVoucher();
    });
  }
}